import session from "./endpoints/session";
import validationResult from "./endpoints/validationResult";

export default {session, validationResult}